import { render, staticRenderFns } from "./WidgetDashboard.vue?vue&type=template&id=58f3ce6e"
import script from "./WidgetDashboard.vue?vue&type=script&lang=js"
export * from "./WidgetDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports